import React from "react";
import LegalPage from "@/components/LegalPage";

export default function Terms() {
  return (
    <LegalPage title="Terms & Conditions" testid="terms-page">
      <p>
        These terms govern your use of <strong>colleenprosserart.com.au</strong> and any purchase
        made through this website. By browsing or buying you agree to be bound by them. Please
        read them carefully.
      </p>

      <h2>1. The Artist &amp; This Site</h2>
      <p>
        This website is owned and operated by Colleen Prosser ("the Artist", "we", "us"). All
        artworks offered for sale are original works by the Artist.
      </p>

      <h2>2. Ordering an Artwork</h2>
      <p>
        Every painting is a one-of-one original. Once an artwork is sold it is automatically
        removed from public sale. Placing an item in your cart does not reserve it &mdash; an
        order is only confirmed when payment is successfully processed by Stripe and you receive
        an on-screen confirmation.
      </p>

      <h2>3. Pricing &amp; Currency</h2>
      <p>
        Prices are listed in Australian Dollars (AUD) and include GST where applicable. Free
        delivery is included in the price for orders shipped within Australia.
      </p>

      <h2>4. Payment</h2>
      <p>
        Payments are processed by <a href="https://stripe.com" target="_blank" rel="noreferrer">
        Stripe</a>, a PCI-DSS compliant payment provider. We never see or store your full card
        details. You agree to Stripe's terms when completing checkout.
      </p>

      <h2>5. Delivery</h2>
      <p>
        Delivery within Australia is free. Artworks are dispatched within 7 business days of
        cleared payment using a tracked, insured courier. International delivery is by quote
        only &mdash; please <a href="/contact">contact us</a> before purchasing if you are
        outside Australia.
      </p>

      <h2>6. Copyright</h2>
      <p>
        Copyright in every artwork remains with the Artist. Purchasing an original does not
        transfer reproduction rights. You may not reproduce, photograph for commercial use,
        print or licence the artwork without the Artist's prior written consent.
      </p>

      <h2>7. Cultural Material</h2>
      <p>
        Some works contain stories, symbols or designs of cultural significance. These remain
        the cultural property of the Artist and her community. Please treat them with respect.
      </p>

      <h2>8. Liability</h2>
      <p>
        To the extent permitted by Australian Consumer Law, our liability is limited to the
        purchase price of the artwork. We do not exclude any guarantees that cannot lawfully be
        excluded.
      </p>

      <h2>9. Governing Law</h2>
      <p>
        These terms are governed by the laws of the State of South Australia, Australia.
      </p>

      <h2>10. Contact</h2>
      <p>
        Questions about these terms? Email{" "}
        <a href="mailto:colleen.prosser@outlook.com">colleen.prosser@outlook.com</a>.
      </p>

      <p className="text-xs uppercase tracking-widest text-[#5B5653] pt-8 border-t border-[#E3DDD7]">
        Last updated: {new Date().toLocaleDateString("en-AU", { month: "long", year: "numeric" })}
      </p>
    </LegalPage>
  );
}
